$('#EvaluationWizard').steps({

  onChange: function (CurrentIndex, NextIndex, Direction) {

    /**
     * Only validate when going forward
     */
    if (Direction === 'forward') {

      /**
       * Validate current block
       */
      if (!$('#EvaluationWizardForm').parsley().validate(`block-${CurrentIndex}`)) {
        $("#ValidationError").removeClass('d-none');
        return false;
      }

      /**
       * Check validation error visiblity
       */
      if (!$("#ValidationError").hasClass("d-none")) {
        $("#ValidationError").addClass('d-none');
      }

      return true;
    }

    return true;
  },

  onFinish: function () {

    var Form = $('#EvaluationWizardForm');

    if (!$(Form).parsley().isValid()) {
      $("#ValidationError").removeClass('d-none');
      return false;
    }

    $.ajax({
      method: Form.attr('method'),
      url: Form.attr('action'),
      data: $(Form).serialize(),
      headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
      },

      success: function (data) {

        if (data) {
          window.location.replace(data);
        }
      }
    });
  }
});